import PropTypes from 'prop-types';
import React from 'react';
import ErrorIcon from './ErrorIcon';
import ErrorMessage from './ErrorMessage';
import CardHeader from 'components/VisualizationStrategies/shared/CardHeader';
import './Error.css';

const ErrorContent = ({isAccessDenied}) => (
  <div>
    <div className="Error__Icon">
      <ErrorIcon isAccessDenied={isAccessDenied} size={ErrorIcon.SIZES.THUMB} />
    </div>
    <div className="Error__Message">
      <ErrorMessage isAccessDenied={isAccessDenied} />
    </div>
  </div>
);

ErrorContent.propTypes = {
  isAccessDenied: PropTypes.bool,
};

export const ErrorDetails = ({isAccessDenied}) => (
  <div className={`Error Error--details`}>
    <ErrorContent isAccessDenied={isAccessDenied} />
  </div>
);

export const ErrorCard = ({card, isAccessDenied}) => (
  <div className={`Error`}>
    {card ? <CardHeader card={card} /> : null}
    <ErrorContent isAccessDenied={isAccessDenied} />
  </div>
);
